export default "__VITE_ASSET__caf897c7__"